type DefaultTransfers = {
  toHotel?: App.ExperienceTransferView
  toAirport?: App.ExperienceTransferView
}
type BestOptions = {
  bestToHotelOption?: App.ExperienceTransferOption | undefined
  bestToAirportOption?: App.ExperienceTransferOption | undefined
}
export function getOneClickTransfersItems(transfer: App.ExperienceBookingView, travellers: App.ExperienceTransferTravellers, defaultTransfers: DefaultTransfers, bestOptions: BestOptions, specialRequest: string) {
  const airportTransfer = defaultTransfers.toAirport
  const hotelTransfer = defaultTransfers.toHotel

  const purchaseToHotel: App.ExperienceTransferView | undefined = hotelTransfer ? {
    ...hotelTransfer,
    travellers: {
      ...travellers,
      // if we have no children, reset the seats. We only kept them around in case the user
      // flicked back and forth between having children and not for convenience
      boosterSeats: travellers.children ? travellers.boosterSeats : 0,
      childSeats: travellers.children ? travellers.childSeats : 0,
    },
    type: hotelTransfer.type,
    flightNumber: hotelTransfer.flightNumber || '',
    time: hotelTransfer.time || '',
    date: hotelTransfer.date,
    option: bestOptions.bestToHotelOption,
    title: transfer.title,
    specialRequests: specialRequest,
  } : undefined

  const purchaseToAirport: App.ExperienceTransferView | undefined = airportTransfer ? {
    ...airportTransfer,
    travellers: {
      ...travellers,
      // if we have no children, reset the seats. We only kept them around in case the user
      // flicked back and forth between having children and not for convenience
      boosterSeats: travellers.children ? travellers.boosterSeats : 0,
      childSeats: travellers.children ? travellers.childSeats : 0,
    },
    type: airportTransfer.type,
    flightNumber: airportTransfer.flightNumber || '',
    time: airportTransfer.time || '',
    date: airportTransfer.date,
    option: bestOptions.bestToAirportOption,
    title: transfer.title,
    specialRequests: specialRequest,
  } : undefined

  const result = { transfers: [purchaseToHotel, purchaseToAirport].filter(Boolean) }

  const toHotel = result.transfers.find(transfer => transfer?.type === 'AIRPORT-TO-HOTEL')
  const toAirport = result.transfers.find(transfer => transfer?.type === 'HOTEL-TO-AIRPORT')

  return {
    toHotel,
    toAirport,
  }
}
